import axios from 'axios';

export const getMediaDetails = async (mediaId) => {
    try {
        const url = `${process.env.REACT_APP_WP_API_URL_V2}/media/${mediaId}`;
        const response = await axios.get(url);

        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des médias (ID: ${mediaId}) :`, error);
        return null;
    }
};
